import { useLocation } from 'react-router-dom';
// @ts-expect-error file not migrated yet
import ProgressTransferContainer from '../../../../containers/Modals/ProgressTransferContainer';
import { useAwardsByTrack } from '../../myTeamQueries';
import { useMemo } from 'react';
import getLang from '../../../../utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
const ProgressTransferModal = ({
  isOpen,
  onClose
}) => {
  const location = useLocation();
  const {
    awardsByTrack
  } = useAwardsByTrack();
  const searchParams = new URLSearchParams(location.search);
  const confirmSwap = searchParams.get('confirmSwap');
  const confirmationGuid = searchParams.get('confirmationGuid');
  const shouldVerifyProgressTransfer = Boolean(confirmSwap && confirmationGuid);
  const userAwardsNames = useMemo(() => {
    if (!awardsByTrack) {
      return [];
    }
    return Object.keys(awardsByTrack).map(trackIdKey => {
      const trackId = Number(trackIdKey);
      const award = awardsByTrack[trackId];
      if (!award) {
        return null;
      }
      const language = getLang();
      const languageData = award.languageMetadata[language] || award.languageMetadata['en'] || {};
      return languageData.title;
    });
  }, [awardsByTrack]);
  return /*#__PURE__*/_jsx(ProgressTransferContainer, {
    handleClose: onClose,
    isOpen: isOpen,
    userAwards: userAwardsNames,
    verify: shouldVerifyProgressTransfer
  });
};
export default ProgressTransferModal;